"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    version: "1.1",
    class: "svg-warning",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18.698px",
    height: "19.533px",
    viewBox: "0 0 18.698 19.533",
    style: { "enable-background": "new 0 0 18.698 19.533" },
    "xml:space": "preserve"
};
const _hoisted_2 = /*#__PURE__*/ (0, vue_2.createElementVNode)("path", { d: "M14.426,16.115H4.283c-0.984,0-1.734-0.36-2.111-1.013c-0.377-0.653-0.314-1.482,0.178-2.335l5.072-8.784\n      C7.914,3.13,8.6,2.661,9.354,2.661s1.441,0.469,1.933,1.322l5.072,8.784c0.492,0.853,0.555,1.682,0.178,2.335\n      C16.16,15.755,15.411,16.115,14.426,16.115z M9.354,3.661c-0.376,0-0.766,0.299-1.067,0.822l-5.072,8.784\n      c-0.302,0.522-0.367,1.009-0.178,1.335c0.188,0.326,0.642,0.513,1.245,0.513h10.144c0.603,0,1.057-0.187,1.245-0.513\n      c0.188-0.326,0.124-0.812-0.178-1.335l-5.072-8.784C10.12,3.96,9.731,3.661,9.354,3.661z" }, null, -1 /* HOISTED */);
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("path", { d: "M9.272,14.236c-0.188,0-0.344-0.062-0.467-0.185c-0.124-0.123-0.185-0.279-0.185-0.467\n      c0-0.188,0.061-0.34,0.185-0.457c0.123-0.115,0.278-0.173,0.467-0.173c0.203,0,0.36,0.058,0.472,0.173\n      c0.112,0.116,0.168,0.268,0.168,0.457c0,0.188-0.056,0.344-0.168,0.467S9.475,14.236,9.272,14.236z M9.272,12.184\n      c-0.094,0-0.172-0.031-0.233-0.092s-0.096-0.158-0.103-0.288L8.697,7.102C8.682,6.906,8.726,6.75,8.827,6.635\n      s0.25-0.174,0.445-0.174c0.188,0,0.333,0.058,0.435,0.174c0.101,0.116,0.145,0.271,0.13,0.467l-0.239,4.702\n      c-0.007,0.13-0.04,0.227-0.098,0.288S9.367,12.184,9.272,12.184z" }, null, -1 /* HOISTED */);
const _hoisted_4 = [
    _hoisted_2,
    _hoisted_3
];
const vue_3 = require("vue");
const provider_1 = require("../../../provider/provider");
const SummaryTableEmployeeRowView_vue_1 = __importDefault(require("./SummaryTableEmployeeRowView.vue"));
const common_1 = require("../../../common/common");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SummaryTable',
    setup(__props) {
        const viewModel = (0, vue_3.inject)(provider_1.summaryTableViewModelInjectKey);
        const bulkDeleteSlots = (0, vue_3.inject)(provider_1.summaryTableBulkDeleteInjectKey, async (action) => { return; });
        const rowEls = (0, vue_3.ref)(null);
        const summary = document.querySelector("#summary-table-wrapper");
        // If dynamic rendering is on, maintain a list of rows we've mounted.
        const rowsMounted = (0, vue_3.ref)(new Set());
        const scrollContainer = (0, vue_3.ref)(null);
        // Only render user rows that are in scrolled view.
        const isUsingDynamicRender = (0, vue_3.ref)(false);
        let observer;
        (0, vue_3.onMounted)(() => {
            if (isUsingDynamicRender.value) {
                initDynamicRender();
            }
            scrollContainer.value = document.querySelector('#summary-table-wrapper');
        });
        (0, vue_3.provide)('scrollContainer', scrollContainer);
        function intObsCallback(entries) {
            // Only mount rows intersecting current view to avoid rendering too many rows at once.
            const rowsInCurrentView = new Map();
            for (const e of entries) {
                if (!e.isIntersecting) {
                    continue;
                }
                // Target ids are user ids.
                const existing = rowsInCurrentView.get(e.target.id);
                if (!existing) {
                    rowsInCurrentView.set(e.target.id, e);
                    continue;
                }
                // If multiple entries for a given user row, keep the most recent
                if (existing.time > e.time) {
                    continue;
                }
                rowsInCurrentView.set(e.target.id, e);
            }
            for (const [, e] of rowsInCurrentView) {
                const userId = parseInt(e.target.id);
                if (!userId) {
                    continue;
                }
                rowsMounted.value.add(userId);
            }
        }
        function initDynamicRender() {
            if (!isUsingDynamicRender.value) {
                return;
            }
            if (!rowEls.value) {
                // Failed to find required targets. Do not use dynamic rendering.
                isUsingDynamicRender.value = false;
                return;
            }
            // Show first page of rows on page load.
            const initialPage = Math.min(25, employees.value.length);
            for (let i = 0; i < initialPage; i++) {
                const employee = employees.value[i];
                if (!employee) {
                    continue;
                }
                rowsMounted.value.add(employee.userId);
            }
            const options = {
                root: summary,
                // Show a row that has any amount of intersect.
                threshold: 0,
            };
            const obs = new IntersectionObserver(intObsCallback, options);
            observer = obs;
            for (const rowElRef of rowEls.value) {
                const rowEl = rowElRef.$el;
                obs.observe(rowEl);
            }
        }
        async function bulkDelete(action) {
            await bulkDeleteSlots(action);
        }
        const employees = (0, vue_3.computed)(() => {
            return viewModel?.value.employeeRows || [];
        });
        const dates = (0, vue_3.computed)(() => {
            return viewModel?.value.oplusTimeDateStrings || [];
        });
        const stats = (0, vue_3.computed)(() => {
            return viewModel?.value.stats;
        });
        (0, vue_3.watch)(() => viewModel?.value.tryUseDynamicRendering, (cur, prev) => {
            if (!cur || prev || !summary) {
                return;
            }
            initDynamicRender();
        }, {
            flush: 'post', // Wait for DOM to update before querying.
        });
        (0, vue_3.watch)(() => viewModel?.value.tryUseDynamicRendering, (cur) => {
            if (!cur || !summary) {
                return;
            }
            // Only use the feature if the toggle is on and required elements were selected.
            isUsingDynamicRender.value = true;
        }, {
            immediate: true, // Do not wait for DOM.
        });
        // Add/remove header highlight when hovered cell changes
        (0, vue_3.watch)(() => viewModel?.value.hoveredDate, (newDate, oldDate) => {
            if (oldDate) {
                document.getElementById(`header-${oldDate}`)?.classList.remove('date-highlight');
            }
            if (newDate) {
                document.getElementById(`header-${newDate}`)?.classList.add('date-highlight');
            }
        });
        // For rows that were mounted after intersection observer init, add to observation.
        function handleRowMount(el) {
            if (!isUsingDynamicRender.value || !observer) {
                return;
            }
            observer.observe(el);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "#main-table" }, [
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(employees.value, (e) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SummaryTableEmployeeRowView_vue_1.default, {
                            ref_for: true,
                            ref_key: "rowEls",
                            ref: rowEls,
                            "show-data-cells": isUsingDynamicRender.value ? rowsMounted.value.has(e.userId) : true,
                            key: e.userId,
                            employee: e,
                            dates: dates.value,
                            stats: stats.value,
                            onMounted: handleRowMount
                        }, null, 8 /* PROPS */, ["show-data-cells", "employee", "dates", "stats"]));
                    }), 128 /* KEYED_FRAGMENT */))
                ])),
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "#bulk-delete-all" }, [
                    (0, vue_2.createElementVNode)("button", {
                        class: "btn delete-btn",
                        onClick: _cache[0] || (_cache[0] = ($event) => (bulkDelete((0, vue_2.unref)(common_1.SlotBulkDeleteAction).All)))
                    }, [
                        ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("svg", _hoisted_1, _hoisted_4)),
                        (0, vue_2.createTextVNode)(" 全て ")
                    ])
                ])),
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "#bulk-delete-unlocked" }, [
                    (0, vue_2.createElementVNode)("button", {
                        class: "btn delete-btn",
                        onClick: _cache[1] || (_cache[1] = ($event) => ((0, vue_2.unref)(bulkDeleteSlots)((0, vue_2.unref)(common_1.SlotBulkDeleteAction).UnlockOnly)))
                    }, " 未確定のみ ")
                ]))
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
